import {
  EntityStatusAuth,
  EntityStatusDesc,
} from '../../../models/entity.model'
import {
  SupplierOrderChangeStatusAction,
  SupplierOrderPermission,
  SupplierOrderRowStatus,
  SupplierOrderStatus,
} from '../models/supplier-order.types'

export const SUPPLIER_ORDER_STATUSES_ACTIVE = [
  'CONFIRMED',
  'ASSIGNED',
  'RECEIVED',
]

export const SUPPLIER_ORDER_STATUSES: EntityStatusDesc<SupplierOrderStatus>[] =
  [
    {
      code: 'DRAFTED',
      name: 'DRAFTED',
      primary: true,
      tooltip: 'Draft supplier order, ready to be confirmed',
    },
    {
      code: 'CONFIRMED',
      name: 'CONFIRMED',
      primary: true,
      tooltip: 'Supplier order ready to be added to a goods receive',
    },
    {
      code: 'ASSIGNED',
      name: 'ASSIGNED',
      primary: true,
      tooltip:
        'One or more rows of this supplier order have been assigned to a goods receive. Waiting for the goods to be received',
    },
    {
      code: 'RECEIVED',
      name: 'RECEIVED',
      primary: true,
      tooltip:
        'One or more rows of this supplier order have been received and loaded into the warehouse',
    },
    {
      code: 'CLOSED',
      name: 'CLOSED',
      primary: true,
      tooltip:
        'Supplier order is definitively closed. All incoming goods assigned to the order rows have been processed',
    },
    {
      code: 'CANCELED',
      name: 'CANCELED',
      primary: false,
      tooltip: 'Supplier order canceled',
    },
  ]

export const SUPPLIER_ORDER_ROW_STATUSES: EntityStatusDesc<SupplierOrderRowStatus>[] =
  [
    {
      code: 'DRAFTED',
      name: 'DRAFTED',
    },
    {
      code: 'CONFIRMED',
      name: 'CONFIRMED',
    },
    {
      code: 'ASSIGNED',
      name: 'ASSIGNED',
    },
    {
      code: 'RECEIVED',
      name: 'RECEIVED',
    },
    {
      code: 'CANCELED',
      name: 'CANCELED',
    },
    {
      code: 'CLOSED',
      name: 'CLOSED',
    },
  ]

export const SUPPLIER_ORDER_ACTIONS: EntityStatusAuth<
  SupplierOrderChangeStatusAction,
  SupplierOrderPermission
> = {
  DRAFTED: {
    permissions: ['addProducts', 'editHeader', 'saveOrder', 'deleteOrder'],
    actions: [
      {
        label: 'Confirm order',
        action: 'confirm',
      },
    ],
  },
  CONFIRMED: {
    permissions: [
      'addProducts',
      'editHeader',
      'saveOrder',
      'cancelOrder',
      'closeOrder',
    ],
    actions: [],
  },
  ASSIGNED: {
    permissions: [],
    actions: [],
  },
  RECEIVED: {
    permissions: [],
    actions: [
      {
        label: 'Close order',
        action: 'close',
      },
    ],
  },
  CANCELED: {
    permissions: [],
    actions: [],
  },
  CLOSED: {
    permissions: ['editNotes', 'saveOrder'],
    actions: [],
  },
}
